import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useMemo, useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import {StudentActionTypes} from "../index";
import {Modal} from "antd";
import {withProps} from "recompose";
import {FetchStudentById} from "../components/FetchEntity";
import {useStudent} from "../Student/useStudent";
import StudentViewCard from "../Student/StudentViewCard";
import {CreateStudentModal, EditStudentModal} from "../Student/StudentForm";
import LoadingBlock from "../../../LoadingBlock";

export const useStudentForm = ({
                                   owner_type, owner_id,
                                   autoRefresh = true,
                               }) => {
    const t = useTranslate()

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const {
        refreshKey,
        onCreate = NullAsDefault,
        onUpdate = NullAsDefault,
        onDelete = NullAsDefault,
    } = useStudent({
        onCreated: onCancel,
        onUpdated: onCancel,
        onDeleted: onCancel,
        onLinked: onCancel,
    })

    const confirmDelete = useCallback(
        (id) => {
            if (id) {
                showDeleteConfirmDialog({
                    translate: t,
                    title: 'delete student',
                    message: 'are you sure you want to delete this student',
                    onOk: () => {
                        onDelete({}, {id})
                    },
                })
            }
        },
        [onDelete]
    )

    const handleAction = (action, params) => {
        switch (action) {
            case StudentActionTypes.STUDENT_DETAIL:
            case StudentActionTypes.STUDENT_UPDATE:
            case StudentActionTypes.STUDENT_CREATE:
                setAction({type: action, value: params})
                break
            case StudentActionTypes.STUDENT_DELETE:
                confirmDelete(params?.id)
                break
            default:
                break
        }
    }

    const modal = useMemo(() => {
        const {id} = action?.value ?? {}
        let title
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        let params = {fullname: undefined}
        let modal_params = {}
        switch (action?.type) {
            case StudentActionTypes.STUDENT_DETAIL:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide 222-222">
                        {t('student information')}
                    </div>
                )
                params = {
                    item: action?.value
                }
                modal_params = {
                    width: 600,
                    footer: undefined,
                    cancelText: t('close'),
                    okButtonProps: {
                        hidden: true,
                    },
                    cancelButtonProps: {
                        className: 'text-color-400 button-rounded-lg no-border',
                    },
                }
                Content = StudentViewCard
                Wrapper = withProps({id})(FetchStudentById)
                break
            case StudentActionTypes.STUDENT_CREATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('create student of organization')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onCreate(values, {
                            id: owner_id,
                            type: owner_type,
                        })
                    },
                }
                modal_params = {
                    width: 720,
                }
                Content = CreateStudentModal
                break
            case StudentActionTypes.STUDENT_UPDATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('edit student')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {id})
                    },
                }
                modal_params = {
                    width: 720,
                }
                Content = EditStudentModal
                Wrapper = withProps({id})(FetchStudentById)
                break
            default:
                break
        }
        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                                item={item}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type])

    return {
        refreshKey,
        modal,
        onCancel,
        handleAction,
    }
}
